export default __webpack_public_path__ + "static/layout-anatomy-light-1b84cac130968b15ad8632246ae5969e51f960deeac50f80275856e90f75b0a9.png";